import { useEffect, useState, useCallback } from 'react'
import { Grid, TextField, Typography, CircularProgress } from '@material-ui/core'
import useStyles from './styles'
import { Autocomplete } from '@material-ui/lab'
import { useSetorService } from 'hooks/useSetorService'
import constants  from 'utils/constants'



export const FormAlterarSituacaoVestigio = (props) => {
	const { form, handleChange } = props
	const classes = useStyles()
	const setorService = useSetorService()
	const [processandoSetores, setProcessandoSetores] = useState(false)
	const [setoresDestinoVestigio, setSetoresDestinoVestigio] = useState([])

	const fetchSetoresDestinoVestigio = useCallback(async () => {
	const response = await setorService.listarSetoresAsync(setProcessandoSetores)
	setSetoresDestinoVestigio(response)
	}, [])

	useEffect(() => {
	fetchSetoresDestinoVestigio()
	}, [fetchSetoresDestinoVestigio])

	const situacoesVests = [
    { label: 'Vestígio para entrega ao destino final', slug: constants.STATUS_CENTRAL_CUSTODIA.PARA_ENTREGA },
    { label: 'Vestígio para armazenamento', slug: constants.STATUS_CENTRAL_CUSTODIA.PARA_ARMAZENAMENTO },
	{ label: 'Vestígio para descarte', slug: constants.STATUS_CENTRAL_CUSTODIA.PARA_ENTREGA_DESCARTE },
  ]

	return (
		processandoSetores ? (
			<div className={classes.carregando}>
				<CircularProgress disableShrink />
			</div>
			) : (
			<Grid container className={classes.container} spacing={3}>
				<Grid item md={12} sm={12} xs={12} lg={12}>
					<Typography className={classes.gridTitle}>ALTERAR SITUAÇÃO DE VESTÍGIO</Typography>
				</Grid>
				<Grid className={classes.item} item md={12} sm={12} xs={12}>
					<Autocomplete
						name="situacaoVest"
						value={situacoesVests.find((opt) => opt.slug === form.situacaoVest) || null}
						noOptionsText="Sem informações"
						options={situacoesVests}
						onChange={(event, newValue) => {
							handleChange('situacaoVest', newValue ? newValue.slug : null)
							handleChange('numDocumento', null)
							handleChange('setEntregaVest', null)
						}}
						getOptionLabel={(option) => option.label}
						isOptionEqualToValue={(option, value) => option.slug === value?.slug}
						renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							label={'SITUAÇÃO DO VESTÍGIO'}
							InputLabelProps={{
							shrink: true,
							}}
							required
						/>
						)}
					/>
				</Grid>
				{form.situacaoVest === constants.STATUS_CENTRAL_CUSTODIA.PARA_ENTREGA_DESCARTE && (
					<Grid item md={12} sm={12} xs={12}>
						<TextField
							fullWidth
							label="NÚMERO DO DOCUMENTO"
							name="numDocumento"
							onChange={(event) => {
								handleChange('numDocumento', event.target.value)
							}}
							value={form.numDocumento || ''}
							variant="outlined"
							InputLabelProps={{
							shrink: true,
							}}
							required
						/>
						<Typography variant="caption" className={classes.caracterRestantes}>
							Caracteres restantes: {250 - (form.numDocumento?.length || 0)}
						</Typography>
					</Grid>)}

				{form.situacaoVest !== constants.STATUS_CENTRAL_CUSTODIA.PARA_ARMAZENAMENTO && (
					<Grid className={classes.item} item md={12} sm={12} xs={12}>
						<Autocomplete
						name="setEntregaVest"
						value={form.setEntregaVest}
						noOptionsText="Sem informações"
						options={setoresDestinoVestigio}
						onChange={(event, newValue) => {
							handleChange('setEntregaVest', newValue)
						}}
						getOptionLabel={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
						renderOption={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
						renderInput={(params) => (
							<TextField
							{...params}
							variant="outlined"
							label={'SETOR A SER ENTREGUE O VESTÍGIO'}
							InputLabelProps={{
								shrink: true,
							}}
							required
							/>
						)}
						/>
					</Grid>)}
			</Grid>)
	)
}